// extracted by mini-css-extract-plugin
export default {"contentContainer":"TextContentContainer_contentContainer__1hlPt"};